import React from "react";
import { connect } from "react-redux";
import { useMountEffect } from "../../../hooks/LifeCycle";
import IngresoActions from "../../../stores/ingreso/Actions";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import BusquedaCierresCuentasForm from "../components/BusquedaCierresCuentasForm";
import BusquedaCierresCuentasTabla from "../components/BusquedaCierresCuentasTabla";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import useEmpresa from "../../../hooks/useEmpresa";
import ModalLoader from "../../../components/Common/ModalLoader";
import TittleLine from "../../../components/Common/TittleLine";
import { useHistory } from "react-router-dom";
import { EMPRESA } from "../../../utils/Constant";

const BusquedaCierresCuentasScreen = (props) => {
  const {
    formConsultaCierresCuentasData,
    consultarCierresCuentasLoading,
    authUserData,
  } = props;

  const empresa = useEmpresa();

  const history = useHistory();

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  useMountEffect(() => {
    if (!isPrimera || !authUserData?.prestador?.permiteCierreCuenta) {
      history.push("/dashboard");
      return;
    }
  });

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={
        formConsultaCierresCuentasData?.dataCierres?.cierreCuentas?.length > 0
          ? "relative"
          : "fixed"
      }
    >
      <Section>
        <TittleLine title={"Búsqueda de cierres de cuentas"} weight={"bold"} />
      </Section>

      <Section>
        <BusquedaCierresCuentasForm />
      </Section>

      <BusquedaCierresCuentasTabla />

      <CheckRender allowed={consultarCierresCuentasLoading}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={formConsultaCierresCuentasData?.showAlert}>
        <CustomAlert {...formConsultaCierresCuentasData?.alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formConsultaCierresCuentasData: state.ingreso.formConsultaCierresCuentasData,
  formConsultaCierresCuentasLoading:
    state.ingreso.formConsultaCierresCuentasLoading,

  consultarCierresCuentasLoading: state.ingreso.consultarCierresCuentasLoading,
});

const mapDispatchToProps = {
  formConsultaCierresCuentas: IngresoActions.formConsultaCierresCuentas,
  consultarCierresCuentas: IngresoActions.consultarCierresCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(BusquedaCierresCuentasScreen);
